import { Box, Grid, Typography, Button } from "@mui/material"

import ListLink from "./listLink";

const FooterLinksComponent = () => {
    const styles = {
        listerheader: {
            fontSize: '16px',
            fontWeight: 'bold',
            color: 'white',
            marginBottom: '25px'
        },
        storeimage: {
            width: '100px',
            marginTop: '15px',
            cursor: 'pointer'
        }
    }
    const companyList = [
        {
            "title": "About us",
            "url": "est"
        },
        {
            "title": "Blog",
            "url": ""
        },
        {
            "title": "Careers",
            "url": ""
        },
        {
            "title": "Contact us",
            "url": ""
        },
    ];

    const supportList = [
        {
            "title": "Help Center",
            "url": ""
        },
        {
            "title": "Safety Center",
            "url": ""
        },
        {
            "title": "Community Guidelines",
            "url": "https://communitypolicies.conectyu.com/"
        }
    ];

    const legalList = [
        {
            "title": "Terms of use",
            "url": "https://termsofuse.conectyu.com"
        },
        {
            "title": "Cookie Policy",
            "url": "https://cookiepolicy.conectyu.com"
        },
        {
            "title": "Privacy Policy",
            "url": "https://privacypolicy.conectyu.com"
        }
    ];

    const redirectToAppStoreHandler = () => {
        console.log("redirect to app store!");
        window.open("https://apps.apple.com/in/app/conectyu/id6746926910", "_blank");
    };

    const redirectToPlayStoreHandler = () => {
        console.log("redirect to play store!");
    };

    return (
        <Box>
            <Grid container>
                <Grid item sm={1} md={1} lg={1} xl={1}></Grid>
                <Grid item sm={1} md={1} lg={1} xl={1}>
                    <Typography sx={styles.listerheader}>Company</Typography>
                    {
                        companyList.map((item, index) => {
                            return (
                                <ListLink key={index} title={item.title} uri={item.url} />
                            )
                        })
                    }
                </Grid>
                <Grid item sm={1} md={1} lg={1} xl={1}></Grid>
                <Grid item sm={2} md={2} lg={2} xl={2}>
                    <Typography sx={styles.listerheader}>Support</Typography>
                    {
                        supportList.map((item, index) => {
                            return (
                                <ListLink key={index} title={item.title} uri={item.url} />
                            )
                        })
                    }
                </Grid>
                <Grid item sm={1} md={1} lg={1} xl={1}></Grid>
                <Grid item sm={2} md={2} lg={2} xl={2}>
                    <Typography sx={styles.listerheader}>Legal</Typography>
                    {
                        legalList.map((item, index) => {
                            return (
                                <ListLink key={index} title={item.title} uri={item.url} />
                            )
                        })
                    }
                </Grid>
                <Grid item sm={1} md={1} lg={1} xl={1}></Grid>
                <Grid item sm={2} md={2} lg={2} xl={2}>
                    <Typography sx={styles.listerheader}>Install Apps</Typography>
                    <Button
                        onClick={redirectToPlayStoreHandler}
                    >
                        <img src="./assets/playstorepic.svg" style={styles.storeimage} />
                    </Button><br />
                    <Button
                        onClick={redirectToAppStoreHandler}
                    >
                        <img src="./assets/appstorepic.svg" style={styles.storeimage}/>
                    </Button>
                </Grid>
                <Grid item sm={1} md={1} lg={1} xl={1}></Grid>
            </Grid>
        </Box>
    )
};

export default FooterLinksComponent;